import React from 'react'
import PropTypes from 'prop-types'

import Markdown from '../../../components/Markdown/Markdown'

export default function PanelFieldMarkdownValue(props) {
  const { value } = props

  const sanitizedValue = value
    .replace(/^\s+/g, '')
    .replace(/(\n)\s+/g, '\n')
    .replace(/\n/g, '    \n')
    .replace(/[•○●]\s?/g, '- ')
  // .replace(/(\d+)\s?[-.]/g, '$1. ')
  // .replace(/$/g, '  \n')
  // .replace(/^(\d+)\s+?[.-]/g, '$1. ')
  // .replace(/\n(\d+)\s+?[.-]/g, '\n$1. ')
  // .replace(/\n1.\s/g, '\n\n1. ')
  // .replace(/\s\s/g, ' ')

  return (
    <React.Fragment>
      <Markdown>{sanitizedValue}</Markdown>
    </React.Fragment>
  )
}

PanelFieldMarkdownValue.propTypes = {
  value: PropTypes.string,
}
